import React, { useEffect } from 'react'

import { useLocation, useParams } from 'react-router-dom'

import { Section } from '../../..'
import { useProfessors } from '../../../../context'
import { AnyProfile } from '../../../../types'
import ProfileView from '../../../profile/ProfileView'

const ProfessorBio = () => {
  const { professorName } = useParams<{ professorName: string }>()
  const { activeProfessor, professorsList, setActiveProfessor } =
    useProfessors()
  const { pathname } = useLocation()

  useEffect(() => {
    if (!professorsList || !professorName) return
    const target = decodeURIComponent(professorName).toLowerCase()
    const match = professorsList.find(
      (professor) =>
        `${professor.name.toLowerCase()}-${professor.lastname.toLowerCase()}` ===
        target,
    )
    if (match && activeProfessor?.uid !== match.uid) setActiveProfessor(match)
  }, [activeProfessor?.uid, professorName, professorsList, setActiveProfessor])

  if (!activeProfessor) {
    return (
      <Section title="Profesor" childrenClass="full-space-section" withBackBtn>
        <div>Loading...</div>
      </Section>
    )
  }

  return (
    <Section
      title={`${activeProfessor?.name} ${activeProfessor?.lastname}`}
      childrenClass="full-space-section"
      withBackBtn
    >
      <ProfileView
        initialProfile={activeProfessor as AnyProfile}
        isNewUser={pathname === '/nuevo-usuario'}
      />
    </Section>
  )
}

export default ProfessorBio
